var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default",function(){return [_vm._v(_vm._s(null))]},{"src":_vm.src})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }